var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFileIcon = function SvgFileIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M9 3h3.01c.712 0 .986.003 1.238.064.235.058.461.152.668.28.222.138.418.333.92.843l2.99 3.029c.503.51.695.709.831.934.127.21.222.44.279.68.06.258.064.538.064 1.259v6.851c0 .806 0 1.381-.037 1.831-.036.445-.104.726-.216.949a2.33 2.33 0 0 1-1.012 1.025c-.218.113-.492.182-.93.218C16.363 21 15.796 21 15 21H9c-.796 0-1.362 0-1.806-.037-.437-.036-.711-.105-.93-.218a2.33 2.33 0 0 1-1.011-1.025c-.112-.223-.18-.504-.216-.948C5.001 18.322 5 17.746 5 16.94V7.06c0-.806 0-1.381.037-1.831.036-.445.104-.726.216-.949a2.33 2.33 0 0 1 1.012-1.025c.218-.113.492-.182.93-.218C7.637 3 8.204 3 9 3M8.25 16.25h7.5M8.25 12.45h7.5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M14.375 3.727c.121.117.27.265.462.46l2.99 3.029c.2.203.35.358.469.484h-2.921c-.27 0-.443 0-.574-.012a.5.5 0 0 1-.185-.036.45.45 0 0 1-.192-.195.5.5 0 0 1-.038-.193c-.011-.134-.011-.31-.011-.584z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFileIcon);
export { ForwardRef as Icon };
export default "customIcons/file-icon.9a6dc02.svg";